export default function validateDefaultMeasureGroupsName(value?: string) {
  let error;
  return error;
}
